module.exports = __webpack_public_path__ + "static/media/curve1.512b5b98.svg";